import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Auth from "@/pages/Auth";
import Home from "@/pages/Home";
import Scan from "@/pages/Scan";
import Leaderboard from "@/pages/Leaderboard";
import Wallet from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Community from "@/pages/Community";
import Elite from "@/pages/Elite";
import SearchPage from "@/pages/Search";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="jx-bg min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-jixxeo-green animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Auth />} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="/scan" element={<Protected><Scan /></Protected>} />
            <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
            <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/profile/:uid" element={<Protected><Profile /></Protected>} />
            <Route path="/community" element={<Protected><Community /></Protected>} />
            <Route path="/elite" element={<Protected><Elite /></Protected>} />
            <Route path="/search" element={<Protected><SearchPage /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
